import { useLayoutEffect, useState, RefObject } from "react";

/**
 * Renders with `data-starting-style`, forces a reflow, then removes the attribute
 * so CSS entry transitions run. Resets when `open` becomes false.
 */
export function useStartingStyle(open: boolean, ref: RefObject<HTMLElement | null>): boolean {
  const [startingStyle, setStartingStyle] = useState(true);

  useLayoutEffect(() => {
    if (!open) {
      setStartingStyle(true);
      return;
    }
    ref.current?.getBoundingClientRect();
    setStartingStyle(false);
  }, [open, ref]);

  return startingStyle;
}
